import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from '@react-google-maps/api';
import DrawingManager from '../drawing_manager';
import { markerIcons } from '../../app/google_maps';

function onDragEnd({ latLng }) {
  $('#stop_lat').val(latLng.lat());
  $('#stop_lng').val(latLng.lng());
  $('#stop_coordinates').val(`${latLng.lat()}, ${latLng.lng()}`);

  const $form = $('#stop_lat').parents('form');
  if ($form.data('auto-submit')) {
    $form.submit();
  }
}

export default class StopMarker extends Component {
  constructor(props) {
    super(props);
    if (props.selected) { this.subscribeUIEvents(); }
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.selected) {
      return this.unsubscribeUIEvents();
    }
    return this.subscribeUIEvents();
  }

  componentWillUnmount() {
    this.unsubscribeUIEvents();
  }

  unsubscribeUIEvents() {
    $('#stop_radius').off(this.eventName('change'));
  }

  subscribeUIEvents() {
    $('#stop_radius').off(this.eventName('change')).on(this.eventName('change'), ({ currentTarget }) => {
      const $form = $(currentTarget).parents('form');
      if ($form.data('auto-submit')) {
        $form.submit();
      }
    });
  }

  eventName(event) {
    return `${event}.stop${this.props.stop.id}`;
  }

  render() {
    const { stop, selected, stoppableAddresses, onClick } = this.props;
    return (
      <div>
        <Marker
          key={stop.id}
          position={{ lat: stop.lat, lng: stop.lng }}
          icon={stop.kind === 'scholar' ? markerIcons.stopScholar : markerIcons.stopPublic}
          clickable
          draggable={selected && stop.kind === 'scholar'}
          opacity={stoppableAddresses.length === 0 ? 0.15 : 1}
          onClick={() => { onClick(stop); }}
          onDragEnd={onDragEnd}
        />
        <DrawingManager
          selected={selected}
          idPrefix="stop"
          object={stop}
        />
      </div>
    );
  }
}

StopMarker.defaultProps = {
  stoppableAddresses: [],
};

StopMarker.propTypes = {
  stop: PropTypes.shape({
    id: PropTypes.number,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    kind: PropTypes.oneOf(['scholar', 'public_transport']).isRequired,
  }).isRequired,
  stoppableAddresses: PropTypes.arrayOf(PropTypes.shape({
    address_id: PropTypes.number.isRequired,
  })),
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
